export default __webpack_public_path__ + "static/media/opensea.cc16b8e0.svg";